import {
  type WealthboxAdditionalObjects,
  type WealthboxWorkflow,
  type WealthboxWorkflowStep,
  type WealthboxWorkflowTemplate,
} from '../../../../../../../models/Integration'
import { type IntegrationWorkflow, type IntegrationWorkflowStep, type IntegrationWorkflowTemplate } from '../../../../../../../models/IntegrationWorkflow'
import { type IntegrationWorkflowAdapter, toIntegrationWorkflow, toIntegrationWorkflowLists } from '../integrationWorkflow'

export type WealthboxStartWorkflowFields = {
  templateId: string
  label?: string
  startsAt: Date
  milestones: { id: string; date: Date }[]
}

const fromWealthboxStep = (step: WealthboxWorkflowStep): IntegrationWorkflowStep => ({
  id: step.id,
  name: step.name ?? null,
  completedAt: step.completedAt ?? null,
  outcomes: (step.workflowOutcomes ?? []).map((outcome) => ({ id: outcome.id, name: outcome.name ?? null, nextStepId: null })),
})

export const fromWealthboxWorkflow = (workflow: WealthboxWorkflow): IntegrationWorkflow => toIntegrationWorkflow(workflow, fromWealthboxStep)

export const fromWealthboxTemplate = (template: WealthboxWorkflowTemplate): IntegrationWorkflowTemplate => ({
  id: `${template.id}`,
  name: template.name ?? null,
  description: template.description ?? null,
  milestones: (template.workflowMilestones ?? []).map((milestone) => ({ id: milestone.id, name: milestone.name ?? null })),
})

export const wealthboxWorkflowAdapter: IntegrationWorkflowAdapter<WealthboxStartWorkflowFields> = {
  capabilities: { stepNote: false },
  toLists: (additionalObjects) => toIntegrationWorkflowLists(additionalObjects as WealthboxAdditionalObjects, fromWealthboxWorkflow, fromWealthboxTemplate),
  buildStartPayload: (fields, externalId) => ({
    workflow_template: Number(fields.templateId),
    linked_to: { id: externalId, type: 'Contact' },
    label: fields.label,
    starts_at: fields.startsAt.toISOString(),
    workflow_milestones: fields.milestones.map((milestone) => ({ id: milestone.id, milestone_date: milestone.date.toISOString() })),
  }),
  buildCompleteStepPayload: ({ outcomeId }) => (outcomeId ? { complete: true, workflow_outcome_id: outcomeId } : { complete: true }),
}
